import { render } from "./SMSHeader.vue?vue&type=template&id=e27c0c3a"
import script from "./SMSHeader.vue?vue&type=script&lang=js"
export * from "./SMSHeader.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__